import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure to import Bootstrap CSS
import { toast } from "react-toastify";

const Main = () => {
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        image: "",
        name: "",
        email: "",
        last_name: "",
        password: "",
        address: "",
        country: "",
        city: "",
        zip: "",
        latitude: "",
        longitude: "",
    });

    const [errorMessage, setErrorMessage] = useState("");

    const handleShow = (message) => {
        setErrorMessage(message);
        setShowPopup(true);
    };
    const handleClose = () => setShowPopup(false);

    const handleRegistration = async (event) => {
        event.preventDefault();
    
        const formDataToSend = new FormData();
        formDataToSend.append("image", formData.image);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("password", formData.password);
        formDataToSend.append("name", formData.name);
        formDataToSend.append("last_name", formData.last_name);
        formDataToSend.append("address", formData.address);
        formDataToSend.append("city", formData.city);
        formDataToSend.append("country", formData.country);
        formDataToSend.append("zip", formData.zip);
        formDataToSend.append("latitude", formData.latitude);
        formDataToSend.append("longitude", formData.longitude);
    
        try {
            const response = await axios.post(
                "https://ecom.testingwebsitelink.com/api/customer/register",
                formDataToSend,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            console.log("Registration response:", response.data);
            navigate(`/verify-user-otp/${formData.email}`);
            toast.success("Registration successful. Please check your email for OTP verification.");
        } catch (error) {
            console.error("Error registering user:", error);
            const apiMessage = error.response?.data?.message || "Email already exists or another error occurred.";
            handleShow(apiMessage);
        }
    };
    
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prevData) => ({
                ...prevData,
                image: file, // Store the image file
            }));
        }
    };

    
    return (
        <>
                <form onSubmit={handleRegistration}>
                        <h3 className="Auth-form-title">SIGN UP</h3>
                    <div className="Auth-form-content">
                    <div className="form-group mt-3 text-center">
    <label htmlFor="imageUpload" className="image-upload-label">
        {formData.image ? (
            <img
                src={URL.createObjectURL(formData.image)}
                alt="Profile Preview"
                className="image-preview"
            />
        ) : (
            <div className="image-placeholder">Upload Image</div>
        )}
    </label>
    <input
        type="file"
        id="imageUpload"
        name="image"
        accept="image/*"
        onChange={handleImageChange}
        className="form-control mt-1"
        style={{ display: "none" }}
    />
</div>

                    <div className="form-group mt-3">
                            <label>First Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="form-control mt-1"
                                
                                required
                            />
                        </div>
                    <div className="form-group mt-3">
                            <label>Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                className="form-control mt-1"
                              
                                required
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control mt-1"
                               
                                required
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>House Address</label>
                            <textarea
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="form-control mt-1"
                                rows={3}
                                required
                            ></textarea>
                        </div>
                       
                       
                        <div className="form-group mt-3">
                            <label>City</label>
                            <input
                                type="text"
                                name="city"
                                className="form-control mt-1"
                               
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>Country</label>
                            <input
                                className="form-control mt-1"
                                type="text"
                    name="country"
                   
                    value={formData.country}
                    onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group mt-3">
                            <label>Zip Code</label>
                            <input
                                className="form-control mt-1"
                                type="text"
                    name="zip"
                   
                    value={formData.zip}
                    onChange={handleChange}
                                required
                            />
                        </div>
                        
                        {/* <div className="form-group mt-3">
                            <label>Phone Number</label>
                            <input
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="form-control mt-1"
                                placeholder="e.g +99 999 000"
                                required
                            />
                        </div> */}
                        <div className="form-group mt-3">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className="form-control mt-1"
                               
                                required
                            />
                        </div>
                        <div className="d-grid gap-2 mt-3">
                            <button type="submit" className="btn btn-color-login">
                                CREATE ACCOUNT
                            </button>
                        </div>
                        {/* <p className="text-center mt-2">
                            Forgot <a href="#">password?</a>
                        </p> */}
                        <div className="text-center">
                            <Link className="login-link-color" to="/">
                             RETURN TO STORE
                            </Link>
                        </div>
                    </div>
                </form>
                <Modal show={showPopup} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Warning</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{errorMessage}</Modal.Body>
                </Modal>
        </>
    );
};

export default Main;
